import { useNavigate } from 'react-router-dom';
import { formatDateTime } from '../../../lib/datetime';
import type { SourceSystemPanelState } from '../types/source-system';
import { SyncStatusBadge } from './SyncStatusBadge';

interface SourceSystemLogsSectionProps {
  projectUuid: string;
  state: SourceSystemPanelState | null;
}

/**
 * §4 Logs & Run Activity section.
 * Inline preview of the last run with a link to the full Jobs page.
 */
export function SourceSystemLogsSection({ projectUuid, state }: SourceSystemLogsSectionProps) {
  const navigate = useNavigate();
  const run = state?.activeRun ?? state?.lastRun ?? null;

  return (
    <section className="ss-section" aria-labelledby="ss-logs-heading">
      <div className="ss-section__header">
        <h2 className="ss-section__title" id="ss-logs-heading">
          Logs & Run Activity
        </h2>
        <button
          type="button"
          className="ss-section__action"
          onClick={() => navigate(`/project/${projectUuid}/jobs`)}
        >
          View all jobs →
        </button>
      </div>
      <div className="ss-section__body">
        {!run ? (
          <p className="ss-hint">No run history available.</p>
        ) : (
          <div className="ss-log-preview">
            <div className="ss-log-preview__head">
              <SyncStatusBadge status={run.status} />
              <span className="ss-log-preview__time">{formatDateTime(run.startedAt)}</span>
              {run.triggerType === 'manual' && run.triggeredByEmail && (
                <span className="ss-log-preview__by">by {run.triggeredByEmail}</span>
              )}
            </div>
            {run.errorSummary && <p className="ss-log-preview__error">{run.errorSummary}</p>}
            {run.jobRunUuid && (
              <button
                type="button"
                className="ss-log-preview__link"
                onClick={() => navigate(`/project/${projectUuid}/jobs/${run.jobRunUuid}`)}
              >
                View full run details
              </button>
            )}
          </div>
        )}
      </div>
    </section>
  );
}
